<template>
  <div :class="containerClasses">
    <router-view
      :key="routerKey"
      :class="transitionClasses"
    >
      <template
        v-for="(slotObj, index) in siteSlots"
        :slot="slotObj.slot"
      >
        <html-renderer-old
          :key="`${slotObj.slot}-${index}`"
          :template="slotObj.html"
          :app="$store.state.site.content.app"
          :params="$store.state.site.content.params"
          :model="pageModel"
        >
        </html-renderer-old>
      </template>
    </router-view>
  </div>
</template>
<script>
const PAGE_SLOT_NAMES = new Set(['formHeader', 'formFooter']);

export default {
  name: 'bfGlobalRouterViewField',
  mixins: [VueFormGenerator.abstractField],
  
  computed: {
    siteSlots() {
      const slots = _.get(this.$store.state.site, 'content.slots', []);
      if (!Array.isArray(slots)) return [];
      return slots.filter((slot) => slot && PAGE_SLOT_NAMES.has(slot.slot));
    },

    pageModel() {
      return this.$store.getters.getFormSchema(0).model || {};
    },

    /**
     * Container classes from schema
     */
    containerClasses() {
      const schema = this.schema || {};
      return schema.fieldClasses || 'router-view-container';
    },
    
    /**
     * Transition classes for page transitions
     */
    transitionClasses() {
      const schema = this.schema || {};
      return schema.transitionClass || this.$store.state.site.pageTransitionClasses || '';
    },
    
    /**
     * Router key for proper re-rendering on route changes
     * Uses full path to ensure component updates
     */
    routerKey() {
      return this.$route ? this.$route.fullPath : 'default';
    }
  },
  
  errorCaptured(err, vm, info) {
    BF.errorThrow(10022, 'BF router-view element error, (See info for details)', { 
      name: err.name, 
      message: err.message,
      info: info 
    });
    return false;
  }
};
</script>

<style scoped>
.router-view-container {
  width: 100%;
  height: 100%;
}
</style>

